import React from 'react';
import {
  BrowserRouter as Router, Routes, Route,
} from 'react-router-dom';
import { AuthProvider, useAuth } from './Components/context/AuthContext';
import Login from './Components/Auth/Login'; // Fixed import path
import Unauthorized from './Components/Auth/Unauthorized';
import ProtectedRoute from './Components/ProtectedRoute';
import Home from './Components/Home/home';
import Ambulance from './Components/Ambulance';
import DoctorById from './Components/FetchDoctorById';
import FindDoctorByOrder from './Components/FindDoctorByOrder';
import Nav from './Components/Nav/Nav';
import AddContent from './Components/AddContent';
import DoctorForm from './Components/Forms/DoctorForm';
import UpdateDoctor from './Components/Forms/UpdateDoctor';
import Footer from './Components/Footer';
import Feedback from './Components/Feedback';
import FeedbackForm from './Components/Forms/FeedbackForm';
import ContactUs from './Components/ContactUs';
import BloodBank from './Components/BloodBank';
import DistrictPage from './Components/DistrictDoctorPage';
import HospitalClinic from './Components/Chambers/HospitalClinic';
import DiagnosticCenters from './Components/Chambers/Diagnostics';
import './App.css';

// Moved AppContent component outside of the main App component
const AppContent = () => {
  const { loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Nav />
        <div className="App flex-grow">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            {/* Protected Routes */}
            <Route
              path="/add-content"
              element={(
                <ProtectedRoute requiredRole="admin">
                  <AddContent />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/add-doctor"
              element={(
                <ProtectedRoute requiredRole="admin">
                  <DoctorForm />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/update-doctor"
              element={(
                <ProtectedRoute requiredRole="admin">
                  <UpdateDoctor />
                </ProtectedRoute>
              )}
            />

            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/ambulance" element={<Ambulance />} />
            <Route path="/emergency" element={<div>Emergency Page</div>} />
            <Route path="/doctors/:id" element={<DoctorById />} />
            <Route path="/find-doctor-by-order" element={<FindDoctorByOrder />} />
            <Route path="/clinics" element={<HospitalClinic />} />
            <Route path="/diagnostics" element={<DiagnosticCenters />} />
            <Route path="/pharmacy" element={<div>Pharmacy Page</div>} />
            <Route path="/blood-bank" element={<BloodBank />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/add-feedback" element={<FeedbackForm />} />
            <Route path="/disclaimer" element={<div>Disclaimer Page</div>} />
            <Route path="/about" element={<div>About Page</div>} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/districts" element={<DistrictPage />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
};

// Main App component
const App = () => (
  <AuthProvider>
    <AppContent />
  </AuthProvider>
);

export default App;
